import { readItems } from '@directus/sdk';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { directusClient } from '../../services/directusClient/directusClient.ts';

export const useVenuesItemsQuery = ({ search }: { search: string }) =>
  useQuery({
    placeholderData: keepPreviousData,
    queryKey: ['venues', { search }],
    queryFn: () =>
      directusClient.request(
        readItems(
          'venues',
          search !== ''
            ? {
                filter: {
                  _or: [
                    {
                      commercial_name: {
                        _icontains: search,
                      },
                    },
                    {
                      business_name: {
                        _icontains: search,
                      },
                    },
                    {
                      city: {
                        _icontains: search,
                      },
                    },
                    {
                      address: {
                        _icontains: search,
                      },
                    },
                    {
                      postal_code: {
                        _icontains: search,
                      },
                    },
                  ],
                },
              }
            : {},
        ),
      ),
  });
